/**
 * This file is replaced in the 'npm run build:version' script.
 */
export const RXDB_VERSION = '16.16.0';
